<template>
  <InputText
    allowedChars="0-9"
    :label="label"
    :icon="icon"
    :identifier="identifier"
    :initialValue="initialValue"
    :validations="computedValidations"
    :informationTooltipContent="informationTooltipContent"
    :forcedValidations="forcedValidations"
    :maxLength="maxLength"
    @onChange="data => $emit('onChange', data)"
    @onInput="data => $emit('onInput', data)"
  />
</template>

<script>
import InputText from "./InputText.vue";
/**
 * @description Composant générique pour l'entrée de nombres. Contient un InputText à l'intérieur
 * @author Félix Bordage
 * @author Alexandre Gallant
 * @author Samuel Dube
 * @vue-prop {String} icon - Icône affichée pour l'input
 * @vue-prop {String} label - Étiquette affichée pour l'input
 * @vue-prop {String} identifier - Identifiant de l'input
 * @vue-prop {Number} minimum - Nombre minimum que l'utilisateur peut insérer
 * @vue-prop {Number} maximum - Nombre maximum que l'utilisateur peut insérer
 * @vue-prop {String} initialValue - Valeur initiale de la saisie
 * @vue-prop {String} informationTooltipContent - Le message à afficher pour le tooltip d'information (null pour qu'il n'y en est pas)
 * @vue-prop {Number} forcedValidations - Nombre de validations forcées (les validations sont exécutées lorsque la valeur change)
 * @vue-prop {Number} maxLength - La longueur maximale du nombre
 * @vue-computed {Array} computedValidations - Retourne toutes les validations à effectuer
 */
export default {
  name: "InputTextNumber",
  components: {
    InputText
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: true
    },
    minimum: {
      type: Number,
      required: false,
      default: Number.MAX_VALUE * -1
    },
    maximum: {
      type: Number,
      required: false,
      default: Number.MAX_VALUE
    },
    initialValue: {
      type: String,
      required: false,
      default: ""
    },
    informationTooltipContent: {
      type: String,
      required: false,
      default: null
    },
    maxLength: {
      type: Number,
      required: false,
      default: 10
    },
    forcedValidations: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    computedValidations() {
      return [
        {
          error: this.$i18n.t("errors.empty", { name: this.label }),
          exec: v => v !== ""
        },
        {
          error: this.$i18n.t("errors.maximum", { max: this.maximum }),
          exec: v => v <= this.maximum
        },
        {
          error: this.$i18n.t("errors.minimum", { min: this.minimum }),
          exec: v => v >= this.minimum
        }
      ];
    }
  }
};
</script>
